<template>
    <section :class="`metrics-display --${mode}`">
        <metric-view v-if="showSapMetric"
                     class="metrics-display__metric --sap"
                     :metric="sapScore" />
        <metric-view class="metrics-display__metric --fuel-bill"
                     :metric="fuelBill" />
        <metric-view class="metrics-display__metric --co2"
                     :metric="co2" />
    </section>
</template>

<script>

import MetricView from './metric'

import MetricsMultiSourceProvider from '@/components/metrics-multi-source-provider'

export default {

    props: {
        mode: {
            type: String,
            default: 'builder',
        },
    },

    mixins: [
        MetricsMultiSourceProvider,
    ],

    components: {
        MetricView,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_metrics-display.scss

.metrics-display {
    font-size: 1rem;
}

</style>
